import axios from "axios";
import { ActionType } from "redux/actionTypes/index";
import { Dispatch } from "redux";
import cookie from "js-cookie";
import config from "config/config";
import { clearAllData } from "../../util/index";
import { AppCookies } from "util/constants";

const enum Environment {
  PROD = 'PROD',
  DEV = 'DEV',
  LOCAL = 'LOCAL'
}

export function login(params: any, setModal: any) {
  return async function (dispatch: Dispatch) {
    try {
      const data = {
        email: params.email,
        password: params.password,
      };

      await axios
        .post(`${config.defaults.api_url}/api/v3/auth/login`, data, {
          method: "POST",
        })
        .then((user) => {
          console.log(user, "USER.............................");

          if (window.location.hostname === "localhost") {
            generateAuthCoookies(user);
          } else {
            generateAuthCoookies(user, true);
          }

          dispatch({
            type: ActionType.USER_LOGIN_SUCCESS,
            payload: user.data?.data,
          });
        });
    } catch (error: any) {
      if (error.response.data.message === "Password Expired") {
        setModal(true);
      }
      dispatch({
        type: ActionType.USER_LOGIN_FAIL,
        payload: {
          message:
            "The Email Address or Password entered is invalid. Please try again.",
        },
      });
    }
  };
}

export const setThemeColor = (profileData: any) => (dispatch: Dispatch) => {
  dispatch({
    type: ActionType.USER_PROFILE_DATA,
    payload: profileData
  });
}

export const setSocketPayload = (socketData: any) => (dispatch: Dispatch) => {
  dispatch({
    type: ActionType.SET_SOCKET_DATA,
    payload: socketData
  });
}

export const setSocketDisconnected = (isDisconnected: boolean) => (dispatch: Dispatch) => {
  dispatch({
    type: ActionType.SET_SOCKET_DISCONNECTED,
    payload: isDisconnected
  });
}

export function requestResendPassword(params: any) {
  const data = {
    email: params.email,
    password: params.password,
  };
  return axios
    .put(`${config.defaults.api_url}/api/v3/auth/resend-password`, data, {
      method: "PUT",
    }).then((res) => res?.data)
}

export function changePassword(params: any) {
  return async function (dispatch: Dispatch) {
    try {
      if (params.old_password) {
        await axios
          .post(
            `${config.defaults.api_url}/api/v3/admin/change-password`,
            params,
            {
              method: "POST",
            }
          )
          .then((res) => {
            dispatch({
              type: ActionType.USER_CHANGE_PASSWORD_SUCCESS,
              payload: res.data?.data,
            });
          });
      } else {
        await axios
          .post(
            `${config.defaults.api_url}/api/v3/admin/change-password-force`,
            params,
            {
              //change api to new force change api
              method: "POST",
            }
          )
          .then((res) => {
            dispatch({
              type: ActionType.USER_CHANGE_PASSWORD_SUCCESS,
              payload: res.data?.data,
            });
            cookie.remove(AppCookies.forgot_password);
          });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: ActionType.USER_CHANGE_PASSWORD_FAIL,
        payload: {
          message: "Failed to change password. Please try again.",
        },
      });
    }
  };
}

export function forgotPassword(params: any) {
  return async function (dispatch: Dispatch) {
    try {
      await axios
        .post(
          `${config.defaults.api_url}/api/v3/auth/forgot-password`,
          params,
          {
            method: "POST",
          }
        )
        .then((res) => {
          if (res.data?.data?.message === "Account not found!") {
            dispatch({
              type: ActionType.USER_FORGOT_PASSWORD_FAIL,
              payload: res.data?.data,
            });
          } else {
            dispatch({
              type: ActionType.USER_FORGOT_PASSWORD_SUCCESS,
              payload: res.data?.data,
            });
          }
        });
    } catch (error) {
      console.log(error);
      dispatch({
        type: ActionType.USER_FORGOT_PASSWORD_FAIL,
        payload: {
          message: "Failed to forgot password. Please try again.",
        },
      });
    }
  };
}

export const logoutService = async (isForceLogout = false) => {

  const res = await axios
  .post(
    `${config.defaults.api_url}/api/v3/auth/logout${isForceLogout ? '?force=true' : ''}`,
    {},
    {
      //change api to new force change api
      method: "POST",
    }
  );

  return res?.data?.data || {};
}

export const clearDataOnLogout = () => (dispatch: Dispatch) => {
  clearAllData()
  dispatch({
    type: ActionType.RESET_REDUCER_ACTIVITY,
  });
  dispatch({
    type: ActionType.RESET_REDUCER_CLASSROOMS,
  });
  dispatch({
    type: ActionType.RESET_MANAGEMENT_REDUCER,
  });
  dispatch({
    type: ActionType.RESET_CLEVER_CSV_REDUCER,
  });
  dispatch({
    type: ActionType.RESET_DISTRICT_CSV_REDUCER,
  });
  dispatch({
    type: ActionType.RESET_CLASS_CSV_REDUCER,
  });
  dispatch({
    type: ActionType.RESET_OBJECTIVE_REDUCER,
  });
  dispatch({
    type: ActionType.USER_LOGOUT,
    payload: {},
  });
}

export function logout(isForceLogout = false) {
  return async function (dispatch: Dispatch) {

    await logoutService(isForceLogout);

    clearAllData()
    dispatch({
      type: ActionType.RESET_REDUCER_ACTIVITY,
    });
    dispatch({
      type: ActionType.RESET_REDUCER_CLASSROOMS,
    });
    dispatch({
      type: ActionType.RESET_MANAGEMENT_REDUCER,
    });
    dispatch({
      type: ActionType.RESET_CLEVER_CSV_REDUCER,
    });
    dispatch({
      type: ActionType.RESET_DISTRICT_CSV_REDUCER,
    });
    dispatch({
      type: ActionType.RESET_CLASS_CSV_REDUCER,
    });
    dispatch({
      type: ActionType.RESET_OBJECTIVE_REDUCER,
    });
    dispatch({
      type: ActionType.USER_LOGOUT,
      payload: {},
    });
  };
}

const setAuthCookies = (data:any, secure: boolean = false, environment:Environment) => {
  const expires = 3600 * 1000 * 24 * 365 * 10;
  const isSameSite = environment === Environment.DEV || environment === Environment.PROD;
  const isParentDomain = environment === Environment.PROD;

  const excludedKeys = ["no_thanks_clicked", "show_no_thanks", "id", "show_survey", "fk_role_id", "actions"]
  const filteredKeys = Object.keys(data).filter(key => !excludedKeys.includes(key))
  filteredKeys.forEach((key: any) => {

    const cookieName = AppCookies[key];
    
    cookieName && cookie.set(cookieName, data[key], {
      expires,
      secure,
      ...(isSameSite && {sameSite: 'None'}),
      ...(isParentDomain && {domain: '.aplustesting.org'})
    });
  });

  cookie.set(AppCookies.user, JSON.stringify(data), {
    expires,
    secure,
    ...(isSameSite && {sameSite: 'None'}),
    ...(isParentDomain && {domain: '.aplustesting.org'})
  });
}

const generateAuthCoookies = (data: any, secure: boolean = false) => {


  if (secure){
    if(window.location.host === 'teacher.aplustesting.org' || window.location.host === 'aplustesting.org' ) {
      setAuthCookies(data.data.data, secure, Environment.PROD);
    } else {
      setAuthCookies(data.data.data, secure, Environment.DEV)
    }
  }
  else {
    setAuthCookies(data.data.data, secure, Environment.LOCAL)
  }
  
};

export function loginWithClever(params: any) {
  return async function (dispatch: Dispatch) {
    try {
      await axios
        .post(
          `${config.defaults.api_url}/api/v3/auth/clever-login/${params.code}`,
          {
            method: "POST",
          }
        )
        .then((user) => {
          if (user) {
            console.log(user, "USER.............................");

            if (window.location.hostname === "localhost") {
              generateAuthCoookies(user);
            } else {
              generateAuthCoookies(user, true);
            }

            dispatch({
              type: ActionType.USER_LOGIN_SUCCESS,
              payload: user.data?.data,
            });
          }
        })
    } catch (error: any) {
      console.log(error, ' $$ Error ', error?.response, ' @@ response ', error?.response?.data, ' !! data');
      console.log(error.response.data.message, ' &&&&& Login Error Message');
      if (error.response.data.message === 'Redirect to student.') {
          window.location.assign('https://v3-student.aplustesting.org' + window.location.search);
      } else  {
          dispatch({
              type: ActionType.USER_LOGIN_FAIL,
              payload: {
                  message: error.response.data.message || "Failed to Login with Clever",
              },
          });
      }
    }
  };
}

export function fetchUserMenu() {
  return async function (dispatch: Dispatch) {
    try {
        await axios
          .get(
            `${config.defaults.api_url}/api/v3/admin/user/menu`,
            {
              method: "GET",
            }
          )
          .then((res) => {
            dispatch({
              type: ActionType.USER_PROFILE_DATA,
              payload: res.data?.data,
            });
          });
    } catch (error) {
      console.log(error);
      dispatch({
        type: ActionType.USER_PROFILE_DATA_FAIL,
        payload: {
          message: "Failed to fetch user profile.",
        },
      });
    }
  };
}

export function updateProfileColor(colorId: number) {
  return async function (dispatch: Dispatch) {
    try {
        await axios
          .put(
            `${config.defaults.api_url}/api/v3/admin/colors/${colorId}`,
            {},
            {
              method: "PUT",
            }
          )
          .then((res) => {
            fetchUserMenu();
          });
    } catch (error) {
      console.log(error);
      dispatch({
        type: ActionType.USER_PROFILE_DATA_FAIL,
        payload: {
          message: "Failed to fetch user profile.",
        },
      });
    }
  };
}
